import EditorAbstractField from "./EditorAbstractField.mjs";
import EditorSubOptions from "./EditorSubOptions.mjs";
import {Label} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";

const EditorRadioField = class extends EditorAbstractField {
	field() {
		return(
			<>
				{ this.textareaField() }
				<div className={"fieldRow RadioField"}>
					<Label>
						<TextLabel value={"Options"} />
					</Label>
					<EditorSubOptions
						key={this.state.changes}
						options={this.state.value?.options}
						setValue={o => this.setValue('options', o)}
					/>
				</div>
			</>
		)
	}
}

export default EditorRadioField;